import { render, staticRenderFns } from "./ChapterContent.vue?vue&type=template&id=31df55f2"
import script from "./ChapterContent.vue?vue&type=script&lang=js"
export * from "./ChapterContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports